import { render, staticRenderFns } from "./WidgetCarouselProductsTab.vue?vue&type=template&id=522f8a0e&scoped=true"
import script from "./WidgetCarouselProductsTab.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselProductsTab.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselProductsTab.vue?vue&type=style&index=0&id=522f8a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f8a0e",
  null
  
)

export default component.exports